import { get, post } from '@/common/request';

const roleMap = new Map([
  ['search', '/role/search']
]);

export default roleMap;

export function userSearch(keyword: string): Promise<any> {
  return get('/role/search', { keyword }, { proxyApi: '/mirage', needHint: true });
}

/**
 * 角色列表
 * https://yapi.lanhanba.com/project/317/interface/api/33591
 */
export async function roleList(params?: any) {
  return get('/role/list', { ...params }, { proxyApi: '/mirage', needHint: true });
}

/**
 * 修改权限
 * https://yapi.lanhanba.com/project/317/interface/api/33596
 */
export async function modifyPermission(params?: any) {
  return post('/role/grantAuthorize', { ...params }, { proxyApi: '/mirage', needHint: true });
}

